import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {BooKingservice} from "../booking.service";
import {Helper} from '../../../../app/utils/helper.module';

import {Order} from "../order";
import {Ticket} from "../ticket";
import {Pricing} from "../pricing";
import {Paiement} from "../paiement";
import {Payment} from "./payment";
import {BookingList} from "../../event/bookingList";
import {FonctionUtiles} from "../../fonctionsUtiles";
import {Router} from "@angular/router";
import {AuthService} from "../../../core/auth/auth.service";

@Component({
  selector: 'app-booking-confirm',
  templateUrl: './booking-confirm.component.html',
  styleUrls: ['./booking-confirm.component.css'],
  providers :[BooKingservice]
})

export class BookingConfirmComponent implements OnInit {

  embeded: boolean = false;
  order : Order;
  tickets : Ticket[] = [];
  bookingLists : BookingList[] = [];
  pricings : Pricing[];
  event : any;
  dayname : string;
  hours : number;
  day : number;
  month : string;
  condition : boolean=false;
  paiement : Paiement;
  payment : boolean = false;
  payement : Payment = new Payment();
  ref : any;
  result : any;
  error : boolean=false;
  canceled :boolean=false;
  expirationTime:number;
  deadLineConfirm :boolean = false;
  passwordIntputs = {'password':'','passwordConfirm':''};

  constructor(private bookingservice :BooKingservice, @Inject(PLATFORM_ID) private platformId: Object , public functionUtils:FonctionUtiles,private router: Router,private authservice:AuthService) {
    this.expirationTime = this.bookingservice.retrieve('sessionExpirationTime');

    if(this.bookingservice.retrieve('embeded')) {
      this.embeded = this.bookingservice.retrieve('embeded');
    }
  }

  moveToInscriptionSuccess() {
    this.router.navigate(['inscription/payment/success']);
  }

  getPricingPrice(pricing) {
    return this.functionUtils.getPricingPrice(pricing);
  }

  scrollToTop() {
    this.functionUtils.displayMessages();
  }

  ngOnInit() {
    this.scrollToTop();
    if (isPlatformBrowser(this.platformId) && localStorage != undefined) {
      this.payement.order_id = this.bookingservice.retrieve('orderSaved').id;
      this.order   = this.bookingservice.retrieve('orderSaved');
      this.order =  this.bookingservice.retrieve('orderSaved');
      this.result =  this.bookingservice.retrieve('result');
      this.bookingLists =  this.bookingservice.retrieve('bookingList');
      this.pricings = this.bookingservice.retrieve('pricings');
      this.event = this.bookingservice.retrieve('event');
      this.event.has_registration_module = parseInt(this.event.has_registration_module);
    }
  }
  getUser() {
    return this.authservice.getUser();
  }
  onSubmit() {
    if(this.getUser()) {
      this.passwordIntputs['user_id'] = this.getUser().id;
      this.bookingservice.addPasswordToPreaccount(this.passwordIntputs).then(res => {
        if(res !='error') {
          this.authservice.storeUser(res);
        }
      })
    }
  }

}
